import { MimshakData } from "../mimshakData";
export interface IReorderable {
  id?: number;
  order?: number;
}

export enum UserTaskType {
    TRANSFER_IN = "TRANSFER_IN",
    TRANSFER_OUT = "TRANSFER_OUT",
    FEE_CHANGE = "FEE_CHANGE",
    NEW_CLIENT = "NEW_CLIENT",
    JOIN_POLICY = "JOIN_POLICY",
    OTHER = "OTHER",
    JOIN_REJECT = "JOIN_REJECT",               // ריגקטים בהצטרפות
    DEPOSIT_TRACKING = "DEPOSIT_TRACKING",      // מעקב הפקדות - כולל גם הפקדה חד-פעמית וגם שינוי הוראת קבע
    WITHDRAWAL = "WITHDRAWAL",                  // מעקב פדיונות ומשיכות
    LOAN_TRACKING = "LOAN_TRACKING",             // מעקב הלוואות
    CONSULTING = "CONSULTING",                   // ייעוץ פנסיוני
    POWER_OF_ATTORNEY = "POWER_OF_ATTORNEY",     // ביטול ייפוי כוח
    AGENT_UPDATE = "AGENT_UPDATE",               // שינוי פרטי סוכן
    LOST_ACCOUNT_TRACKING = "LOST_ACCOUNT_TRACKING", // חשבונות מנותקי קשר
    AGENT_APPOINTMENT = "AGENT_APPOINTMENT",     // בוצע מינוי סוכן
    AGENT_CANCELLATION = "AGENT_CANCELLATION" ,   // ביטול מינוי סוכן
    BENEFICIARY_UPDATE = "BENEFICIARY_UPDATE",   // עדכון מוטבים - נבדק בפרודוקציה של החודש הבא בלבד
    VIEW_POWER_OF_ATTORNEY = "VIEW_POWER_OF_ATTORNEY", // ייפוי כוח לצפייה - לכל יצרן (מסלקה / בית השקעות)
    PATH_CHANGE="PATH_CHANGE",
  }
  export enum UserTaskStatus {
    PENDING = "PENDING",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
    IGNORED = "IGNORED",
    REJECTED = "REJECTED"
  }
 
  export enum UserTaskOrigin {
    SIMULATION = "SIMULATION",
    MANUAL = "MANUAL",
    SYSTEM = "SYSTEM",
    EXTERNAL = "EXTERNAL"
  }
export enum UserTaskPriority {
    LOW = "Low",
    MEDIUM = "Medium",
    HIGH = "High",
    URGENT = "Urgent"
}
export enum UserTaskSystemStatus {
    UNCHECKED = "UNCHECKED",       // יש קישור לסימולציה, עדיין לא נבדק בכלל
    PENDING = "PENDING",           // נבדק, אין עדיין נתוני מסלקה רלוונטיים לתקופה
    AWAITING = "AWAITING",         // נבדק, הערך עדיין זהה למקורי - בדיקה ראשונה בלבד
    MATCH = "MATCH",               // נבדק בהצלחה, הערך תואם את המבוקש
    MISMATCH = "MISMATCH",         // נבדק בהצלחה, הערך לא תואם את המבוקש
    FAILED = "FAILED",             // ריצת הבדיקה עצמה נכשלה
}

export class UserTask implements IReorderable {
  id: number;
  status: UserTaskStatus;
  contact_id: number;
  created_by: number;
  board_id?: number;
  list_id?: number;
  task_type: UserTaskType;
  policy_number?: string;
  product_type?: number;
  adjusted_product_type?: number;
  handler_code?: string;
  reported_period?: string;
  description?: string;
  assigned_to_id?: number;
  title?: string;
  agent?: string;
  priority?: UserTaskPriority;
  order?: number;
  color?: string;
  start_date?: string;
  due_date?: string;
  completed_date?: string;
  created_at?: string;
  updated_at?: string;
  system_notes?: string;
  simulation_id?: number;
  simulation_mimshak_data_id?: number;
  origin?: UserTaskOrigin;
  system_status?: UserTaskSystemStatus;
  system_status_updated_at?: string;
  change_types?: string[]; // SimulationChangeType-ים מה-SimulationMimshakData המקושרת (שדה נגזר בלבד)

  constructor(init?: Partial<UserTask>) {
    Object.assign(this, init);
  }

  static defaultEmpty(contactId: number, createdBy: number): UserTask {
    return new UserTask({
      contact_id: contactId,
      created_by: createdBy,
      status: UserTaskStatus.PENDING,
      task_type: UserTaskType.OTHER,
      priority: UserTaskPriority.MEDIUM,
      title: "",
    });
  }
}

export class UserTaskList implements IReorderable  {
  id?: number;
  board_id: number;
  name: string;
  order: number;
  color?: string;
  created_by: number;
  created_at?: string;
  updated_at?: string;

  constructor(init?: Partial<UserTaskList>) {
    Object.assign(this, init);
  }

  static defaultEmpty(boardId: number, createdBy: number): UserTaskList {
    return new UserTaskList({
      board_id: boardId,
      name: "",
      order: 0,
      color: "#ffffff",
      created_by: createdBy,
    });
  }
}
export class UserTaskComment {
  id?: number;
  task_id: number;
  contact_id: number;
  content: string;
  created_at?: string;
  updated_at?: string;

  constructor(init?: Partial<UserTaskComment>) {
    Object.assign(this, init);
  }

  static defaultEmpty(taskId: number, userId: number): UserTaskComment {
    return new UserTaskComment({
      task_id: taskId,
      contact_id: userId,
      content: "",
    });
  }
}
export class UserTaskBoard {
  id?: number;
  name: string;
  description?: string;
  color?: string;
  created_by: number;
  is_archived: boolean;
  created_at?: string;
  updated_at?: string;

  constructor(init?: Partial<UserTaskBoard>) {
    Object.assign(this, init);
  }

  static defaultEmpty(createdBy: number): UserTaskBoard {
    return new UserTaskBoard({
      name: "",
      description: "",
      color: "#ffffff",
      created_by: createdBy,
      is_archived: false,
    });
  }
}
export class UserTaskAttachment {
  id?: number;
  task_id: number;
  file_name: string;
  file_path: string;
  file_size?: number;
  uploaded_by: number;
  document_type?: string;
  created_at?: string;

  constructor(init?: Partial<UserTaskAttachment>) {
    Object.assign(this, init);
  }

  static defaultEmpty(taskId: number, uploadedBy: number): UserTaskAttachment {
    return new UserTaskAttachment({
      task_id: taskId,
      file_name: "",
      file_path: "",
      file_size: undefined,
      uploaded_by: uploadedBy,
    });
  }
}

export interface UserTaskMimshakData extends MimshakData {
    // ✅ ניתן להוסיף כאן שדות חדשים אם נדרש
    user_task_type: UserTaskType;
    user_task_status: UserTaskStatus;
  }

  export interface ReorderMove {
    id: number;
    parent_list_id?: number;
    order?: number;
  }
